import OspreyApiHelper from './helper'

export default class OspreyMessages {

    static get(path, params) {
        return OspreyApiHelper.genericGet(path, params)
    }

    static put(path, params) {
        return OspreyApiHelper.genericPut(path, params.message)
    }

    static post(path, params) {
        return OspreyApiHelper.genericPost(path, params)
    }

    static delete(path) {
        return OspreyApiHelper.genericDelete(path)
    }
}


// WEBPACK FOOTER //
// src/services/osprey-api/api-messages.js